// extracted by mini-css-extract-plugin
export default {"statusWrap":"Status_statusWrap__ASked","statusText":"Status_statusText__tQOv3"};